import { render, staticRenderFns } from "./ViewContract.vue?vue&type=template&id=23f9f9e2&scoped=true&"
import script from "./ViewContract.vue?vue&type=script&lang=ts&"
export * from "./ViewContract.vue?vue&type=script&lang=ts&"
import style0 from "./ViewContract.vue?vue&type=style&index=0&id=23f9f9e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9f9e2",
  null
  
)

export default component.exports